<template>
  <p>
    <router-link to="/MasterDetail">Master Detail</router-link>
    <router-link to="/MultiGrid">Multi Grid</router-link>
    <router-link to="/ThreeGrids">다중 그리드 연동</router-link>
    <router-link to="/TotalGrid">소계 / 합계 그리드</router-link>
    <router-link to="/DnDGrid">드래그&amp;드롭</router-link>
    <router-link to="/FrontPaging">Paging</router-link>
    <!-- <router-link to="/DBPaging">DB Paging</router-link> -->
    <router-link to="/ManyColumns">100 Columns</router-link>
    <router-link to="/MergeGrid">데이터 병합</router-link>
    <router-link to="/PersonalizeGrid">개인화</router-link>
    <router-link to="/ContextMenu">컨텍스트 메뉴</router-link>
    <router-link to="/ImportExport">불러오기 / 내보내기</router-link>
    <router-link to="/ExampleCode">📝 Vue 예시코드</router-link>
  </p>
</template>

<script>
export default {

}
</script>

<style scoped>
p {
    width: 280px;
    border-right: 1px solid #41b883;
    list-style: none;
    font-size: 0;
}
a {
  font-size: 15px;
  overflow: hidden;
  display: inline-block;
  width: 279px;
  height: 5vh;
  line-height: 5vh;
  text-align: center;
  cursor: pointer;
  background: #f6f6f6;
  border-bottom: 1px solid #ccc;
  text-decoration: none;
  color: inherit;
  transition: 0.3s all;
}
a:hover:not(.router-link-active) {
    color: #42b883
}
.router-link-active {
  background: #42b883;
  color: #fff;
  transition: 0.3s all;
}
</style>